<template>
  <div class="pjmain">
    <div class="content" v-cloak>
      <div class="pjxqtitle">
        <div class="sm-tit" style="margin-bottom: 10px">缴费信息</div>
        <p><span>收入名称：</span>{{ jfxq.name }}</p>
        <p><span>小区名称：</span>{{ jfxq.villageName }}</p>


        <p><span>营业公司名称：</span>{{ jfxq.unitName }}&nbsp;&nbsp;</p>
        <p><span>营业公司联系人：</span>{{ jfxq.linkName }}&nbsp;&nbsp;</p>
        <p><span>营业公司联系电话：</span>{{ jfxq.linkPhone||"暂无"}}&nbsp;&nbsp;</p>


        <p><span>公共广告收入：</span>{{ jfxq.gggg }}&nbsp;&nbsp;元</p>
        <p><span>公共场地收入：</span>{{ jfxq.ggcd }}&nbsp;&nbsp;元</p>
        <p><span>公共区域停车收入：</span>{{ jfxq.ggtc }}&nbsp;&nbsp;元</p>
        <p><span>公共设施经营收入：</span>{{ jfxq.ggss }}&nbsp;&nbsp;元</p>
        <p><span>公共区域临时摊位收入：</span>{{ jfxq.ggtw }}&nbsp;&nbsp;元</p>
        <p><span>其他收入：</span>{{ jfxq.qt }}&nbsp;&nbsp;元</p>
        <p>

          <span>总收入：</span>{{ jfxq.total || "0" }}&nbsp;&nbsp;元
        </p>
        <p><span>备注：</span>{{ jfxq.bz }}</p>
      </div>

      <div class="sm-tit" v-if="jfxq.isPay !== '已缴'">
        <div class="bt md20">
          <button @click="jf()" class="btn">缴费</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Image as VanImage, ImagePreview, Tab, Tabs, Step, Steps } from "vant";

Vue.use(VanImage);
Vue.use(ImagePreview);
Vue.use(Step);
Vue.use(Steps);
export default {
  data() {
    return {
      lcno: 0,
      tsxq: {},
      jfxq: { address: "0 0 0 0 1", houseOwnerName: "" },
      trueName:''
    };
  },
  mounted() {
    var id = this.$route.query.id;
    this.$axios
      .get("/api/v1/jSbank/viewOne?id=" + id)
      .then((res) => {
        this.jfxq = res;
      });
  },
  methods: {
    jf() {

      var that=this
      let data = new FormData();

//判断小数点
      var rep=/[\.]/;
      var total="";
      if(rep.test(that.jfxq.total)){
        total=that.jfxq.total
      }else{
        total=that.jfxq.total.toFixed(2)
      }
      var jsonData={
            id:that.$route.query.id,
            totalFee:total,
            validTime:'10000',
            backUrl:'https://zhwy.zjj.suqian.gov.cn/zhwy_mobile/index.html#/ggsy',
            proInfo:'物业公共收益代缴费',
            attach:'',
            shopId:that.jfxq.villageId,
            operatorId:'',
            outTradeNo:that.$route.query.id,
            extf1d1:'',
            extf1d2:'',
            extf1d3:'',
				}

      for(let key in jsonData) {
        data.append(key,jsonData[key]);
      }
      this.$axios
        .post("/api/v1/jSbank/ggsyAtPay", data)
        .then(res=> {
          // debugger
          console.log("🚀 ~ file: jfdetail.vue:104 ~ .then ~ res:", res)
          if(res.payUrl){
            window.location.href = res.payUrl;
          }
        });
    },
  },
};
</script>
<style lang="less" scoped>
[v-cloak] {
  display: none;
}
.bt {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.md20 {
  margin-bottom: 20px;
}
.pjmain {
  height: calc(100% - 46px);
  width: 100%;
  background-color: #fff;
}
.shangchuan {
  line-height: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  box-sizing: border-box;
  width: 100%;
  padding: 10px 0px;
  overflow: hidden;
  color: #323233;
  font-size: 14px;
  line-height: 24px;
  border-bottom: #f4f4f4 1px solid;
  font-size: 16px;
}
.pj-dv {
  // border-top: 1px solid #f4f4f4;
  margin-top: 20px;
}
.mt10 {
  margin-top: 10px;
}
.sm-tit {
  color: #28aff6;
}
.btn {
  margin-top: 30px;
  outline: none;
  border: none;
  border-radius: 10px;
  color: white !important;
  font-weight: 600;
  background: #28aff6;
  height: 40px;
  width: 70%;
  cursor: pointer;
}
.content {
  height: 100%;
  width: 92%;
  margin: 0 4% 0 4%;
  .pjxqtitle {
    padding: 10px 0;
    font-size: 18px;
    border-bottom: #f4f4f4 1px solid;
    p {
      margin: 5px auto;
      span {
        display: inline-block;
        color: #999999;
        width: 160px;
        text-align: right;
      }
      font-size: 14px;
      color: #000;
      // margin: 0;
      line-height: 2rem;
    }
  }
  .bxqk {
    width: 100%;
    line-height: 25px;
    textarea {
      height: 125px;
      outline: none;
      border: #dddddd 1px solid;
      border-radius: 20px;
      margin-top: 10px;
      margin-bottom: 10px;
      text-indent: 2rem;
      color: #999999;
    }
    p {
      margin: 0;
      padding: 0;
    }
  }
}
.daxing {
  display: flex;
  align-items: center;
  span {
    margin-right: 10px;
  }
}
.tijiao {
  margin-top: 30px;
  margin-bottom: 30px;
  outline: none;
  border: none;
  border-radius: 10px;
  color: white;
  font-weight: 600;
  background: #28aff6;
  height: 40px;
  margin-left: 15%;
  width: 70%;
  cursor: pointer;
}
.dpj {
  height: 25px;
  top: calc(50% - 15px);
  border: 1px solid #00d2ff;
  color: #00d2ff;
  background-color: transparent;
  border-radius: 30px;
  font-size: 15px;
}
</style>